// extracted by mini-css-extract-plugin
export var footer = "_rz-0";
export var inherit = "_rz-1";
export var input = "_rz-2";
export var modalContent = "_rz-3";
export var quillEditor = "_rz-4";
export var subtitle = "_rz-5";